import { ApiError } from 'api/http/types';
import {
  ApiErrorReasonType,
  ApiState,
  BusinessErrorDetail,
} from 'scenes/common/types';
import { WireErrorCode, WireErrorRef } from './types/error.types';

export enum ApiName {
  CreateQuote = 'Create quote',
  UpdateQuote = 'Update quote',
  MonthlyInstalment = 'Monthly instalment',
  PolicyDetails = 'Update quote (Policy details)',
  DataComplete = 'Update quote (Data Complete)',
  BpayBindQuote = 'Bind quote (BPAY payment)',
  DirectDebitBindQuote = 'Bind quote (Direct debit payment)',
  CreditCardBindQuote = 'Bind quote (Credit card payment)',
  SaveQuote = 'Update quote (Save quote)',
}

const promoCodeErrorCodes = [
  'BR000176', // Unfortunately, you are not eligible to use the promotion code which you have entered. Please check the terms and conditions of the promotion and call us if you have further questions
  'BR000209', // We didn't recognise that promotion code
  'BR000210', // We didn't recognise that promotion code
  'BR000211', // We didn't recognise that promotion code
  'BR000212', // Sorry, that promotion code has already been used and cannot be used again
  'BR000213', // Unfortunately, you are not eligible to use the promotion code which you have entered. You can continue to purchase this policy without this promotion or call us if you have further questions
];

export const getErrorReasonType = (
  details: BusinessErrorDetail
): ApiErrorReasonType => {
  if (details.code === WireErrorCode.Referred) {
    return ApiErrorReasonType.Referral;
  }
  if (details.code === WireErrorCode.Declined) {
    return ApiErrorReasonType.Declined;
  }
  if (
    details.ref === WireErrorRef.PromotionCode &&
    promoCodeErrorCodes.includes(details.code)
  ) {
    return ApiErrorReasonType.InvalidPromoCode;
  }
  if (details.type === ApiErrorReasonType.IneligiblePromoCode) {
    return ApiErrorReasonType.IneligiblePromoCode;
  }
  return ApiErrorReasonType.Unknown;
};

export const isBusinessError = (err: Error): boolean =>
  err instanceof ApiError && err.name === ApiState.BusinessError;

export const isPromoCodeError = (reason: ApiErrorReasonType): boolean =>
  [
    ApiErrorReasonType.InvalidPromoCode,
    ApiErrorReasonType.IneligiblePromoCode,
  ].includes(reason);
